import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { useState, useEffect } from 'react';
import { InputLabel } from "@mui/material";
import './SelectionFields.scss';

export const SelectionFields = ({
  label = '',
  listValues,
  initialValues = [],
  callbackFields,
  mode,
  texts = {
    selectAll: 'selectAll',
    deselectAll: 'deselectAll',
    seeSelected: 'seeSelected',
    backSelection: 'backSelection',
    selectValue: 'selectValue',
    seeSelectedFields: 'seeSelectedFields',
    noFields: 'noFields',
  },
  showSeeSelectedButton = true,
  showAutocomplete = true,
  showSelectionButtons = true,
  margin = '',
  itemsContainerHeight,
}) => {
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [seeSelected, setSeeSelected] = useState(false);

  const generateSelectedLabel = (key, { label, information }) => {
    const textLabel = label ? label : key;
    return information ? `${textLabel} (${information})` : textLabel;
  };

  const options = Object.entries(listValues).map(([key, value]) => ({
    key,
    label: value.label,
    tooltip: value.tooltip,
    disabled: selectedKeys.includes(key),
  }));

  const handleChangeAutocompleteValue = (event, value) => {
    if (value) {
      setSelectedKeys((prev) => [...new Set([...prev, value.key])]);
      setInputValue('');
    }
  };

  const handleItemClick = (key) => {
    setSelectedKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  const handleSelectAll = () => {
    setSelectedKeys(options.map((option) => option.key));
  };

  const handleDeselectAll = () => {
    setSelectedKeys([]);
  };

  useEffect(() => {
    callbackFields({
      selectedFields: selectedKeys,
      mode,
    });
  }, [selectedKeys]);

  useEffect(() => {
    const filteredInitialValues = initialValues.map((element) => {
      if (listValues[element]) return element;
    });
    setSelectedKeys(filteredInitialValues);
  }, []);

  return (
    <>
      <div className="selection-fields-container" style={{ margin }}>
        <Box className="selection-container" sx={{ padding: '0' }}>
          <InputLabel sx={{ margin: '12px auto' }}>
            {label}
          </InputLabel>
          <div className="selection-actions">
            {showSelectionButtons && (
              <>
                <Button
                  variant="outlined"
                  onClick={handleSelectAll}
                  disabled={options.length === selectedKeys.length}
                >
                  {texts.selectAll}
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleDeselectAll}
                  disabled={selectedKeys.length === 0}
                >
                  {texts.deselectAll}
                </Button>
              </>
            )}
            {showSeeSelectedButton && (
              <Button
                variant="contained"
                onClick={() => setSeeSelected((prev) => !prev)}
              >
                {seeSelected ? texts.backSelection : texts.seeSelected}
              </Button>
            )}
          </div>
        </Box>
        {seeSelected ? (
          <Box className="selected-items" sx={{ margin: '12px auto' }}>
            {selectedKeys.length > 0 ? (
              <>
                <h6>{texts.seeSelectedFields}:</h6>
                <ul>
                  {selectedKeys.map((key) => (
                    <li key={key}>
                      {generateSelectedLabel(key, listValues[key])}
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              <p>{texts.noFields}</p>
            )}
          </Box>
        ) : (
          <>
            {showAutocomplete && (
              <Autocomplete
                value={null}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) =>
                  setInputValue(newInputValue)
                }
                onChange={handleChangeAutocompleteValue}
                id={`${mode}-autocomplete-selected-fields`}
                options={options}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => (
                  <TextField {...params} label={texts.selectValue} />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.key === value.key
                }
                disableClearable
                getOptionDisabled={(option) => option.disabled}
                style={{ margin: '12px auto', padding: '0', }}
              />
            )}

            <Box
              className="selection-container"
              style={{
                maxHeight: itemsContainerHeight || 'none',
                overflowY: itemsContainerHeight ? 'auto' : 'visible',
                padding: '0',
              }}
            >
              <Grid container spacing={2}>
                {options.map((option) => (
                  <Grid key={option.key} size={{ xs: 12, md: 6 }}>
                    <Tooltip title={option.tooltip} arrow>
                      <div
                        className={`item ${selectedKeys.includes(option.key) ? 'selected' : ''
                          }`}
                        onClick={() => handleItemClick(option.key)}
                      >
                        {option.label}
                      </div>
                    </Tooltip>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </>
        )}
      </div>
    </>
  );
};
